import { useCallback } from "react";
import { SetVisibilityMenu } from "./SetVisibilityMenu";
import { useBulkActionTargets } from "./bulkActionTargetsContext";
import { useEnqueueBulkForm } from "./useEnqueueBulkForm";

export function SetVisibilityMenuBulkAsync() {
  const bulk = useBulkActionTargets();
  const enqueueBulkForm = useEnqueueBulkForm();

  const handleVisibilityChange = useCallback(
    async (visibility: boolean) => {
      await enqueueBulkForm({
        actionType: "SET_FORM_VISIBILITY",
        actionData: { visibility },
      });
    },
    [enqueueBulkForm]
  );

  return (
    <SetVisibilityMenu
      onVisibilityChange={handleVisibilityChange}
      isBulkAction={true}
      isAsyncAction={true}
      formsCount={bulk.selectionSize}
    />
  );
}
